// extracted by mini-css-extract-plugin
export default {"section__draw":"BgLine3--section__draw--5p1z1"};